define('lq/style',[
    'jquery',
    'underscore',
    'lq',
    'lq/util'
], function ($, _, lq, util) {
    'use strict';

    var defaultSupportedFontFamilies = [
        'Arial,Arial,Helvetica,sans-serif',
        'Arial Black,Arial Black,Gadget,sans-serif',
        'Comic Sans MS,Comic Sans MS,cursive',
        'Courier New,Courier New,Courier,monospace',
        'Georgia,Georgia,serif',
        'Impact,Charcoal,sans-serif',
        'Lucida Console,Monaco,monospace',
        'Lucida Sans Unicode,Lucida Grande,sans-serif',
        'Palatino Linotype,Book Antiqua,Palatino,serif',
        'Tahoma,Geneva,sans-serif',
        'Times New Roman,Times,serif',
        'Trebuchet MS,Helvetica,sans-serif',
        'Verdana,Geneva,sans-serif',
        'Gill Sans MT,Gill Sans,Geneva,sans-serif',

        // TheSans
        'TheSans Light Plain, sans-serif',
        'TheSans Light Italic, sans-serif',
        'TheSans Plain, sans-serif',
        'TheSans Italic, sans-serif',
        'TheSans Bold Plain, sans-serif',
        'TheSans Bold Italic, sans-serif',

        //// from fontdeck, trial license (20 IP addresses)
        //'FS Rufus Web Light, Rockwell, Verdana, sans-serif',
        //'FS Rufus Web Light Italic, Rockwell, Verdana, sans-serif',
        //'FS Rufus Web Regular, Rockwell, Verdana, sans-serif',
        //'FS Rufus Web Italic, Rockwell, Verdana, sans-serif',
        //'FS Rufus Web Bold, Rockwell, Verdana, sans-serif',
        //'FS Rufus Web Bold Italic, Rockwell, Verdana, sans-serif',

        // these fonts are temporarily hard coded
        'Abril Fatface, cursive',
        'Asap Bold, sans-serif',
        'Asap Regular, sans-serif',
        'Audi Type Extended Bold',
        'Audi Type Extended Normal',
        'Audi Type Screen Bold',
        'Audi Type Screen Normal',
        'Audi Type Screen Light',
        'Autour One, cursive',
        'Avenir Black, sans-serif',
        'Avenir Book, sans-serif',
        'Avenir Heavy, sans-serif',
        'Avenir Light, sans-serif',
        'Avenir Medium, sans-serif',
        'Avenir Roman, sans-serif',
        'Average Sans, sans-serif',
        'Bad Script, cursive',
        'Bellerose, sans-serif',
        'BNPP Sans, sans-serif',
        'BNPP Sans Light, sans-serif',
        'BNPP Sans Condensed, sans-serif',
        'BNPP Rounded, sans-serif',
        'Cabin, sans-serif',
        'Cabin Bold, sans-serif',
        'Cabin Bold Italic, sans-serif',
        'Cabin Italic, sans-serif',
        'Cabin Medium, sans-serif',
        'Cabin Medium Italic, sans-serif',
        'Cabin Regular, sans-serif',
        'Cabin SemiBold, sans-serif',
        'Cabin SemiBold Italic, sans-serif',
        'Cambo, serif',
        'CantoraOne, sans-serif',
        'Carrois Gothic SC, sans-serif',
        'Chela One, cursive',
        'Chewy, cursive',
        'Combo, cursive',
        'Days One, sans-serif',
        'Didact Gothic, sans-serif',
        'Droid Sans Normal, sans-serif',
        'Droid Sans Bold, sans-serif',
        'Fascinate, cursive',
        'Faster One, cursive',
        '"HelveticaNeueLT Std Extended", sans-serif',
        '"HelveticaNeueLT Std Ext", sans-serif',
        '"HelveticaNeueLT Std Lt Ext", sans-serif',
        'Hind Bold, sans-serif',
        'Hind Light, sans-serif',
        'Hind Regular, sans-serif',
        'Hind Semibold, sans-serif',
        'FontAwesome, cursive',
        'Gravity Bold, sans-serif',
        'Gravity Light, sans-serif',
        'Iceland, cursive',
        'Kavoon, cursive',
        'Market Deco, sans-serif',
        'Meie Script, cursive',
        'Merriweather Sans, sans-serif',
        'Microsoft YaHei, sans-serif',
        'Noto Serif CJK SC Black, serif',
        'Noto Serif CJK SC Bold, serif',
        'Noto Serif CJK SC Extra Light, serif',
        'Noto Serif CJK SC Light, serif',
        'Noto Serif CJK SC Medium, serif',
        'Noto Serif CJK SC Regular, serif',
        'Noto Serif CJK SC Semi Bold, serif',
        'Noto Sans CJK SC Regular, sans-serif',
        'Noto Sans CJK SC Black, sans-serif',
        'Noto Sans CJK SC Bold, sans-serif',
        'Noto Sans CJK SC Demi Light, sans-serif',
        'Noto Sans CJK SC Light, sans-serif',
        'Noto Sans CJK SC Medium, sans-serif',
        'Noto Sans CJK SC Thin, sans-serif',
        'Nunito, sans-serif',
        'Oleo Script Swash Caps, cursive',
        'Open Sans, sans-serif',
        'Open Sans Condensed, sans-serif',
        'Patrick Hand SC, cursive',
        'Paulistana Deco, sans-serif',
        'PT Sans Bold, sans-serif',
        'PT Sans Bold Italic, sans-serif',
        'PT Sans Italic, sans-serif',
        'PT Sans Regular, sans-serif',
        'Quando, serif',
        'Quicksand, sans-serif',
        'Raleway Black, sans-serif',
        'Raleway Black Italic, sans-serif',
        'Raleway Bold, sans-serif',
        'Raleway Bold Italic, sans-serif',
        'Raleway Extra Bold, sans-serif',
        'Raleway Extra Bold Italic, sans-serif',
        'Raleway Extra Light, sans-serif',
        'Raleway Extra Light Italic, sans-serif',
        'Raleway Italic, sans-serif',
        'Raleway Light, sans-serif',
        'Raleway Light Italic, sans-serif',
        'Raleway Medium, sans-serif',
        'Raleway Medium Italic, sans-serif',
        'Raleway Regular, sans-serif',
        'Raleway Semi Bold, sans-serif',
        'Raleway Semi Bold Italic, sans-serif',
        'Raleway Thin, sans-serif',
        'Raleway Thin Italic, sans-serif',
        'Roboto, sans-serif',
        'Roboto Bold, sans-serif',
        'Roboto Bold Italic, sans-serif',
        'Roboto Italic, sans-serif',
        'Roboto Regular, sans-serif',
        'Roboto Slab, serif',
        'Shojumaru, cursive',
        'Sofadi One, cursive',
        'Strong Glasgow, sans-serif',
        'Swanky and Moo Moo, cursive',
        '"Swiss 721 Extended Bold", sans-serif',
        '"Swiss 721 Extended Light", sans-serif',
        '"Swiss 721 Extended Roman", sans-serif',
        'Titillium Web, sans-serif',
        'Unkempt, cursive',
        'Lato, sans-serif',
        'Lato Black',
        'Lato BlackItalic',
        'Lato Bold',
        'Lato BoldItalic',
        'Lato Italic',
        'Lato Light',
        'Lato LightItalic',
        'Lato Regular',
        'Lato Thin',
        'Lato ThinItalic'
    ];

    var supportedTextAligns = [
        'left',
        'center',
        'right'
    ];

    var supportedFontWeights = [
        'normal',
        'bold',
        'bolder',
        'lighter',
        'inherit'
    ];

    var supportedTextTransforms = [
        'none',
        'capitalize',
        'uppercase',
        'lowercase'
    ];

    var supportedHorizontalPositions = [
        'left',
        'center',
        'right'
    ];

    var supportedVerticalPositions = [
        'top',
        'center',
        'bottom'
    ];

    var defaults = {

        enabled: false,

        border: {
            top: false,
            right: false,
            bottom: false,
            left: false,
            style: 'solid',
            color: 'rgba(0, 0, 0, 1)',
            width: 1
        },

        font: {
            size: 14,
            fontFamily: defaultSupportedFontFamilies[0],
            color: 'rgba(0, 0, 0, 1)',
            inheritColor: false,
            weight: supportedFontWeights[0],
            italic: false,
            underline: false
        },

        text: {
            align: supportedTextAligns[0],
            verticalAlign: 'top',
            lineHeight: '',
            textTransform: supportedTextTransforms[0]
        },

        background: {
            enabled: false,
            color: 'rgba(255, 255, 255, 1)'
        },

        padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        },

        boxShadow: {
            enabled: false,
            x: 4,
            y: 4,
            blur: 5,
            spread: 0,
            color: 'rgba(0, 0, 0, 1)'
        },

        textShadow: {
            enabled: false,
            x: 4,
            y: 4,
            blur: 5,
            color: 'rgba(0, 0, 0, 1)'
        },

        textStroke: {
            enabled: false,
            color: 'rgba(0, 0, 0, 1)',
            size: 0
        },

        opacity: 100,

        roundedCorners: {
            enabled: false,
            leftTopRadius: 0,
            rightTopRadius: 0,
            rightBottomRadius: 0,
            leftBottomRadius: 0
        },

        backgroundImage: {
             leftMargin: 0,
             rightMargin: 0
        },

        heading: {
            enabled: false,
            level: 1,
            numberingStyle: 'numeric'
        },

		rotate: 0,

        runtime: false
    };

    var hasTransform = _.has(document.createElement('div').style, 'transform');
    var radianConversionFactor = Math.PI / 180.0;
    var rotateFilterTemplate = _.template("progid:DXImageTransform.Microsoft.Matrix(" +
		"M11=<%= data.cos %>, M12=<%= data.sin %>, M21=<%= -data.sin %>, M22=<%= data.cos %>, SizingMethod='auto expand')",
		undefined, { variable: 'data' });

    var Style = function () {
    };

    Style.prototype.defaultStyles = [];
    Style.prototype.defaultMockStyles = [];
    Style.prototype.mockMode = lq.isInMockMode();

    var customStyleStates = ['dragTarget', 'dragHover', 'selected', 'active', 'normal'];

    Style.prototype.renderStyles = function (drop, classPrefix, $actualElement, actualStyle, customState, customHoverStyle, $requiredIndicatorElement) {
        if (!$actualElement)
            $actualElement = drop.$element;
        if (!actualStyle)
            actualStyle = drop.data.styles;
        if (!$requiredIndicatorElement)
            $requiredIndicatorElement = drop.$element;

    	var prefix = classPrefix || 'userstyle-';

    	if (!actualStyle || ((drop.rootDrop && drop.rootDrop.isMockAction) && this.mockMode)) {
    	    var styleId = this.getDefaultStyleIdByDropType(drop);
    		if (styleId)
    			$actualElement.addClass(this.getClassNameFromStyleId(prefix, styleId));
    	} else if (typeof actualStyle === 'string') {
	        var classNameFromStyleId = this.getClassNameFromStyleId(prefix, actualStyle);

	        $actualElement.addClass(classNameFromStyleId);
	        $actualElement.removeClass(customStyleStates.join(' '));

    	    if (customState)
    	        $actualElement.addClass(customState);

            // styling the required indicator -> should always be applied to drop.$element
    	    $requiredIndicatorElement.addClass(classNameFromStyleId + '-required-indicator');
       	} else {
    	    this.renderCustomStyle(drop, $actualElement, actualStyle, customState, customHoverStyle);
    	}
    };

    Style.prototype.renderSavedStyles = function (drop, classPrefix, $actualElement, actualStyle, customState) {
        if (!actualStyle)
            actualStyle = drop.data.styles;

        if (!$actualElement)
            $actualElement = drop.$element;

        if (typeof actualStyle !== 'string') {
            $actualElement.removeClass(function (i, className) {
                return (className.match(/(^|\s)userstyle-\S+/g) || []).join(' ');
            });

            return;
        }

        var prefix = classPrefix || 'userstyle-';

        var classNameFromStyleId = this.getClassNameFromStyleId(prefix, actualStyle);

        $actualElement.addClass(classNameFromStyleId);
        $actualElement.removeClass(customStyleStates.join(' '));

        if (customState)
            $actualElement.addClass(customState);

        // styling the required indicator -> should always be applied to drop.$element
        drop.$element.addClass(classNameFromStyleId + '-required-indicator');
    };

    Style.prototype.getDefaultStyleIdByDropType = function (drop, ignoreMock) {
        return this.getDefaultStyleIdForComponentByDropType(drop, '', ignoreMock);
    };

    Style.prototype.getDefaultStyleIdForComponentByDropType = function (drop, componentName, ignoreMock) {
        var uncapitalizedComponentName =
            drop.data.type
                .substring(0, 1)
                .toLowerCase()
            + drop.data.type.substring(1)
            + componentName;

        var key = !!drop.data.role ? uncapitalizedComponentName + '_' + drop.data.role : uncapitalizedComponentName;
        if (((drop.rootDrop && drop.rootDrop.isMockAction)) && !ignoreMock && this.mockMode)
            return this.defaultMockStyles[key] || this.defaultMockStyles[uncapitalizedComponentName];
        else return this.defaultStyles[key] || this.defaultStyles[uncapitalizedComponentName];
    };

    Style.prototype.renderStyle = function (style, drop, $actualElement) {
    	if (!$actualElement)
    	    $actualElement = drop.$element;
    	this.renderCss(style, drop, $actualElement);
    };

    Style.prototype.getClassNameFromStyleId = function (prefix, styleId) {
        var id = styleId;
        if (styleId.indexOf('/') > -1)
            id = styleId.split('/')[1];
        return prefix + id;
    };

    Style.prototype.renderCustomStyle = function (drop, $actualElement, actualStyle, customState, customHoverState) {
    	if (actualStyle instanceof Array)
    		var style = util.convertListOfKeyValuesToObject(actualStyle);
    	else
    	    var style = actualStyle;

    	var styleState = style[customState || 'normal'];
    	if (styleState && styleState.enabled)
    	    this.renderCss(styleState, drop, $actualElement);

        if (customState){
            $actualElement.removeClass(customStyleStates.join(' '));
            $actualElement.addClass(customState);
        }

    	$actualElement.off(".licquid-style-hover");

    	var self = this;
    	var hoverStyle = style[customHoverState || 'hover'];
    	if (hoverStyle && hoverStyle.enabled) {
    		$actualElement
                .on("mouseenter.licquid-style-hover", function () {
                    self.renderCss(hoverStyle, drop, $(this));
                })
                .on("mouseleave.licquid-style-hover", function () {
                    if (customState === 'selected' && style.selected && style.selected.enabled)
                        self.renderCss(style.selected, drop, $(this));
                    else
                        self.renderCss(styleState, drop, $(this));
                });
    	}
    };

    Style.prototype.removeStyleClass = function (drop, classPrefix, $actualElement) {
    	if (typeof drop.data.styles != 'string')
    	    return;

        if (!$actualElement)
            $actualElement = drop.$element;

        var prefix = classPrefix || 'userstyle-';
        var className = this.getClassNameFromStyleId(prefix, drop.data.styles);
        $actualElement.removeClass(className);
    };

    Style.prototype.renderCss = function (style, drop, $actualElement) {
        style = $.extend(true, {}, defaults, drop.defaultStyleSettings, style);

    	Style.prototype.resetCss(drop, $actualElement);
    	$actualElement
            .css({
                borderStyle: style.border.style,
                borderColor: style.border.color,
                borderTopWidth: style.border.top ? style.border.width + "px" : 0,
                borderBottomWidth: style.border.bottom ? style.border.width + "px" : 0,
                borderRightWidth: style.border.right ? style.border.width + "px" : 0,
                borderLeftWidth: style.border.left ? style.border.width + "px" : 0,

                fontSize: style.font.size + "px",
                fontFamily: style.font.fontFamily,
                fontWeight: style.font.weight,
                color: style.font.inheritColor ? 'inherit' : style.font.color,
                fontStyle: style.font.italic ? 'italic' : '',
                textDecoration: style.font.underline ? 'underline' : '',

                textAlign: style.text.align,
                textTransform: style.text.transform,
                lineHeight: style.text.lineHeight ? style.text.lineHeight + "px" : "normal",

                background: style.background.enabled ? style.background.color : "transparent",

                outline: '',

                paddingLeft: style.padding.left + "px",
                paddingRight: style.padding.right + "px",
                paddingTop: style.padding.top + "px",
                paddingBottom: style.padding.bottom + "px",

                boxShadow: style.boxShadow.enabled ? style.boxShadow.x + "px " + style.boxShadow.y + "px " + style.boxShadow.blur + "px " + style.boxShadow.spread + "px " + style.boxShadow.color : null,
                textShadow:
                (style.textShadow.enabled ?
                    style.textShadow.x + "px " + style.textShadow.y + "px " + style.textShadow.blur + "px " + style.textShadow.color : "")
                    + (style.textStroke.enabled ? (style.textShadow.enabled ? ", " : "") +
                        style.textStroke.color + " " + style.textStroke.size + "px " + style.textStroke.size + "px, " +
                        style.textStroke.color + " " + (-style.textStroke.size) + "px " + (-style.textStroke.size) + "px, " +
                        style.textStroke.color + " " + (-style.textStroke.size) + "px " + style.textStroke.size + "px, " +
                        style.textStroke.color + " " + style.textStroke.size + "px " + (-style.textStroke.size) + "px "
                        : ""),

                transform: style.rotate ? 'rotate(' + style.rotate + 'deg)' : '',

                borderTopLeftRadius: style.roundedCorners.enabled ? style.roundedCorners.leftTopRadius + "px" : null,
                borderTopRightRadius: style.roundedCorners.enabled ? style.roundedCorners.rightTopRadius + "px" : null,
                borderBottomLeftRadius: style.roundedCorners.enabled ? style.roundedCorners.leftBottomRadius + "px" : null,
                borderBottomRightRadius: style.roundedCorners.enabled ? style.roundedCorners.rightBottomRadius + "px" : null
            });

        var $content = this.getDropTextContent($actualElement);
        if ($content.css("flex-direction") === "column") {
            $content.css({
                justifyContent: this.convertAlignmentValue(style.text.verticalAlign), // vertical (main axis)
                alignItems: this.convertAlignmentValue(style.text.align) // horizontal (cross axis)
            });
        } else {
            $content.css({
                justifyContent: this.convertAlignmentValue(style.text.align), // horizontal (main axis)
                alignItems: this.convertAlignmentValue(style.text.verticalAlign) // vertical (cross axis)
            });
        }

        // only for IE < 11
        // document.documentMode will return true
        // window.MSInputMethodContext will only return true on IE11
        if (style.rotate && !window.MSInputMethodContext && document.documentMode && !hasTransform) {
    	    var rotateRadians = style.rotate * radianConversionFactor;
    	    $actualElement.css({
				'-ms-transform': '', // seems to have issues, so even though ie9 has it, we remove what jquery adds
    	    	filter: rotateFilterTemplate({ sin: Math.sin(rotateRadians), cos: Math.cos(rotateRadians) })
    	    });
    	}

    	// IE 8 messes up png files with transparency when we set the opacity, so only apply this style when really necessary
    	if (style.opacity !== 100) {
    	    $actualElement
                .css({
                    opacity: (style.opacity || 100) / 100
                });
    	}
    };

    Style.prototype.getDropTextContent = function ($actualElement) {
        // can be anywhere in the ancestor tree
        if ($actualElement.hasClass('drop-text-container'))
            return $actualElement.find('.drop-text-content');

        // can only be a direct descendant (needed for drops that contain child drops with their own styling)
        return $actualElement
            .children()
            .addBack()
            .filter('.drop-text-content');
    };

    Style.prototype.convertAlignmentValue = function (value) {
        switch(value) {
            case 'top':
            case 'left':
                return 'start';
            case 'middle':
            case 'center':
                return 'center';
            case 'bottom':
            case 'right':
                return 'end';
            default:
                return value;
        }
    }

    Style.prototype.resetCss = function (drop, $actualElement) {
    	$actualElement
            .css({
                borderStyle: '',
                borderColor: '',
                borderTopWidth: '',
                borderBottomWidth: '',
                borderRightWidth: '',
                borderLeftWidth: '',

                fontSize: '',
                fontFamily: '',
                fontWeight: '',
                color: '',
                fontStyle: '',
                textDecoration: '',

                textAlign: '',
                textTransform: '',
                lineHeight: '',

                background: '',

                paddingLeft: '',
                paddingRight: '',
                paddingTop: '',
                paddingBottom: '',

                boxShadow: '',
                textShadow: '',

                opacity: '',

                transform: '',
                filter: '',

                borderTopLeftRadius: '',
                borderTopRightRadius: '',
                borderBottomLeftRadius: '',
                borderBottomRightRadius: ''
            });

        $actualElement
            .children('.drop-text-content')
            .css({
    	        verticalAlign: ''
    	    });
    };

    Style.prototype.supportedFontFamilies = defaultSupportedFontFamilies;

    Style.prototype.getSupportedFontFamilies = function () {
        return _.sortBy(this.supportedFontFamilies, function (fontName) { return fontName.replace('"', ''); })
            .slice(0); // copy
    };

    Style.prototype.getSupportedTextTransforms = function () {
        return supportedTextTransforms.slice(0);
    };

    Style.prototype.getSupportedTextAligns = function () {
    	return supportedTextAligns.slice(0);
    };

    Style.prototype.getSupportedFontWeights = function () {
    	return supportedFontWeights.slice(0);
    };

    Style.prototype.getSupportedHorizontalPositions = function () {
        return supportedHorizontalPositions.slice(0);
    };

    Style.prototype.getSupportedVerticalPositions = function () {
        return supportedVerticalPositions.slice(0);
    };

    Style.prototype.getDefaults = function () {
    	return $.extend(true, {}, defaults);
    };

    Style.prototype.bestFontSize = function (container, text) {
        var successSize = 0;
        var failingSize = 500;
        text.css('line-height', 'normal');
        while (successSize < (failingSize - 1)) {

            var newFontSize = Math.floor((successSize + failingSize) / 2);
            text.css('font-size', newFontSize);

            if (container.offsetHeight < container.scrollHeight
             || container.offsetWidth < container.scrollWidth) {
                failingSize = newFontSize;
            } else {
                successSize = newFontSize;
            }
        }
        text.css('font-size', successSize);
    };

    return new Style();
});
